/**
 * Pure validation guard for the anonymous-path name-capture form (issue #6).
 * Kept free of DOM calls so it's unit-testable with plain `node --test`.
 *
 * Trims surrounding whitespace and rejects empty/whitespace-only input.
 * Returns the normalized name to send to the backend, or `null` when the
 * guest should be blocked from proceeding.
 */
export function normalizeGuestName(rawName: string): string | null {
  const trimmed = rawName.trim();
  return trimmed.length > 0 ? trimmed : null;
}
